export default "__VITE_ASSET__7836155c__"